<template>
  <section class="id">
    <sk-input :placeholder="placeholder"
              :reg-exp="/[^0-9]/g"
              :mob-numeric-keyboard="true"
              :preselected-value="searchKey"
              @fieldvaluechanged="onInputBoxChanged" />
  </section>
</template>

<script>
  export default {
    data() {
      return {
        searchKey: '',
        requestTimer: ''
      };
    },
    computed: {
      placeholder() { return this.$gettext('ID'); },
    },
    methods: {
      onInputBoxChanged(value) {
        if (value !== this.searchKey) {
          clearInterval(this.requestTimer);
          this.searchKey = value;
          this.requestTimer = setTimeout(() => {
            this.params.parentFilterInstance((instance) => {
              instance.onFloatingFilterChanged('equals', value);
            });
          }, 500);
        }
      },

      onParentModelChanged(parentModel) {
        // When the filter is empty we will receive a null value here
        if (!parentModel) {
          this.searchKey = '';
        } else {
          this.searchKey = parentModel.filter;
        }
      }
    }
  };
</script>

<style>
.id .sk-input {
  margin-bottom: 0;
  background-color: #fff;
  font-weight: normal;
  font-size: 13px;
}
</style>
<style scoped>
.id {
  width: 100%;
  margin: auto;
}
</style>
